import Checkbox from 'Components/Base/Checkbox'
import Column from 'Components/Base/Column'
import Icon from 'Components/Base/Icon'
import Typography from 'Components/Base/Typography'
import React from 'react'
import styled from 'styled-components'
import { IntakeMedication } from 'types/Medication'

interface Props {
  medication: IntakeMedication
  handleSelect: () => void
  removeMedication: (medication: IntakeMedication) => void
}
export default function MedSelectCard({ medication, handleSelect, removeMedication }: Props) {
  return (
    <Card>
      <Checkbox checked={medication.checked ?? false} onClick={() => handleSelect()}></Checkbox>
      <Column styles={{ marginLeft: '2%' }}>
        <Typography>
          {medication.name ?? ''} {medication.strength ?? ''}
        </Typography>
      </Column>
      {medication.patientAdded && (
        <div onClick={() => removeMedication(medication)} style={{ marginLeft: 'auto' }}>
          <Icon name="trashX" styles={{ marginLeft: 'auto', marginTop: 2, cursor: 'pointer' }} color="#98A4AE" />
        </div>
      )}
    </Card>
  )
}

const Card = styled.div`
  padding: 10px 15px;
  margin-bottom: 5px;
  border: 1px solid #98a4ae;
  display: flex;
  max-width: 600px;
  border-radius: 5px;
`
